import { X } from "lucide-react";
import { usePlanURL } from "~/components/plans/hooks/UsePlanURL";
import { Link, LinkProps } from "react-router";
import { useMemo } from "react";

type PropTypes = {
  onClose?: () => void;
};

export const CloseDialogButton = ({ onClose }: PropTypes) => {
  const planURL = usePlanURL();

  const props = useMemo(() => {
    if (onClose) {
      return {
        onClick: (event) => {
          event.preventDefault();
          onClose();
        },
        to: "#",
      } as LinkProps;
    } else {
      return {
        to: planURL,
      } as LinkProps;
    }
  }, [onClose, planURL]);

  return (
    <div className="absolute top-0 right-0 pt-4 pr-4 block">
      <Link
        {...props}
        className="rounded-md bg-transparent text-butter-green hover:text-butter-pink transition-all hover:cursor-pointer"
      >
        <span className="sr-only">Close</span>
        <X aria-hidden="true" className="size-6" />
      </Link>
    </div>
  );
};
